export default {
  name: 'LoaderPerformanceGateMixin',
  computed: {
    isEnabledLoaderPerformanceGate() {
      return (
        this.$abtProvider.isFeatureEnabled('skeleton_loader_enabled') ?? true
      )
    },
  },
}
